import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Enrollment } from './enrollment.model';
import { EnrollmentPopupService } from './enrollment-popup.service';
import { EnrollmentService } from './enrollment.service';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { CRUD_ACTIONS } from '../../shared';

@Component({
    selector: 'jhi-enrollment-delete-dialog',
    templateUrl: './enrollment-delete-dialog.component.html'
})
export class EnrollmentDeleteDialogComponent {

    enrollment: Enrollment;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private enrollmentService: EnrollmentService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(studentGlobalLocations);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.enrollmentService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'enrollmentListModification',
                content: {
                    action: CRUD_ACTIONS.DELETE,
                    content: {id: id}
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-enrollment-delete-popup',
    template: ''
})
export class EnrollmentDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private enrollmentPopupService: EnrollmentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.enrollmentPopupService
                .open(EnrollmentDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment-delete-dialog.component.ts